export const salesPersonConstants = {
    GET_SALESMANAGER_REQUEST:              'GET_SALESMANAGER_REQUEST',
    GET_SALESMANAGER_SUCCESS:              'GET_SALESMANAGER_SUCCESS',
    GET_SALESMANAGER_FAILURE:              'GET_SALESMANAGER_FAILURE',

    ADD_CITY_ACCESS_REQUEST:                'ADD_CITY_ACCESS_REQUEST',
    ADD_CITY_ACCESS_SUCCESS:                'ADD_CITY_ACCESS_SUCCESS',
    ADD_CITY_ACCESS_FAILURE:                'ADD_CITY_ACCESS_FAILURE',

    GET_SALESMANAGER_CITIES_REQUEST: 'GET_SALESMANAGER_CITIES_REQUEST',
    GET_SALESMANAGER_CITIES_SUCCESS: 'GET_SALESMANAGER_CITIES_SUCCESS',
    GET_SALESMANAGER_CITIES_FAILURE: 'GET_SALESMANAGER_CITIES_FAILURE',

    PROMOTE_SALESPERSON_REQUEST:               'PROMOTE_SALESPERSON_REQUEST',
    PROMOTE_SALESPERSON_SUCCESS:               'PROMOTE_SALESPERSON_SUCCESS',
    PROMOTE_SALESPERSON_FAILURE:               'PROMOTE_SALESPERSON_FAILURE',

    GET_SALESMANAGER_QUESTIONS_REQUEST:       'GET_SALESMANAGER_QUESTIONS_REQUEST',
    GET_SALESMANAGER_QUESTIONS_SUCCESS:       'GET_SALESMANAGER_QUESTIONS_SUCCESS',
    GET_SALESMANAGER_QUESTIONS_FAILURE:       'GET_SALESMANAGER_QUESTIONS_FAILURE',

    GET_SALESMANAGER_REPORT_REQUEST:       'GET_SALESMANAGER_REPORT_REQUEST',
    GET_SALESMANAGER_REPORT_SUCCESS:       'GET_SALESMANAGER_REPORT_SUCCESS',
    GET_SALESMANAGER_REPORT_FAILURE:       'GET_SALESMANAGER_REPORT_FAILURE',

    GET_CITIES_REPORT_REQUEST:              'GET_CITIES_REPORT_REQUEST',
    GET_CITIES_REPORT_SUCCESS:              'GET_CITIES_REPORT_SUCCESS',
    GET_CITIES_REPORT_FAILURE:              'GET_CITIES_REPORT_FAILURE',

    GET_SALESMANAGER_QUESDETAIL_REQUEST:  'GET_SALESMANAGER_QUESDETAIL_REQUEST',
    GET_SALESMANAGER_QUESDETAIL_SUCCESS: 'GET_SALESMANAGER_QUESDETAIL_SUCCESS',
    GET_SALESMANAGER_QUESDETAIL_FAILURE: 'GET_SALESMANAGER_QUESDETAIL_FAILURE',

    UPDATE_ANSWER_REQUEST:   'UPDATE_ANSWER_REQUEST',
    UPDATE_ANSWER_SUCCESS:  'UPDATE_ANSWER_SUCCESS',
    UPDATE_ANSWER_FAILURE:   'UPDATE_ANSWER_FAILURE',

    GET_SALESMANAGER_EXPORT_REPORT_REQUEST:   'GET_SALESMANAGER_EXPORT_REPORT_REQUEST',
    GET_SALESMANAGER_EXPORT_REPORT_SUCCESS:       'GET_SALESMANAGER_EXPORT_REPORT_SUCCESS',
    GET_SALESMANAGER_EXPORT_REPORT_FAILURE:       'GET_SALESMANAGER_EXPORT_REPORT_FAILURE',

    GET_HELP_DETAIL_REQUEST:   'GET_HELP_DETAIL_REQUEST',
    GET_HELP_DETAIL_SUCCESS:   'GET_HELP_DETAIL_SUCCESS',
    GET_HELP_DETAIL_FAILURE:   'GET_HELP_DETAIL_FAILURE',

    ADD_HELP_QUESTION_REQUEST:   'ADD_HELP_QUESTION_REQUEST',
    ADD_HELP_QUESTION_SUCCESS:   'ADD_HELP_QUESTION_SUCCESS',
    ADD_HELP_QUESTION_FAILURE:   'ADD_HELP_QUESTION_FAILURE',

    ADD_HELP_REPLY_REQUEST:   'ADD_HELP_REPLY_REQUEST',
    ADD_HELP_REPLY_SUCCESS:   'ADD_HELP_REPLY_SUCCESS',
    ADD_HELP_REPLY_FAILURE:   'ADD_HELP_REPLY_FAILURE',

    GET_MONTH_YEAR_REQUEST:   'GET_MONTH_YEAR_REQUEST',
    GET_MONTH_YEAR_SUCCESS:    'GET_MONTH_YEAR_SUCCESS',
    GET_MONTH_YEAR_FAILURE:    'GET_MONTH_YEAR_FAILURE',

    GET_PROGRESS_REPORT_REQUEST:  'GET_PROGRESS_REPORT_REQUEST',
    GET_PROGRESS_REPORT_SUCCESS:   'GET_PROGRESS_REPORT_SUCCESS',
    GET_PROGRESS_REPORT_FAILURE:  'GET_PROGRESS_REPORT_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/salesPersonConstants.js